"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = embedDataToHtml;
exports.nodeToHtml = exports.getAttributesHtml = void 0;

var _embed = require("../constants/embed");

var getAttributesHtml = function getAttributesHtml(attributes) {
  if (!attributes) {
    return '';
  }

  return attributes.reduce(function (attrsHtml, attribute) {
    var key = attribute.key,
        value = attribute.value;
    return value ? attrsHtml + " " + key + "=\"" + value + "\"" : attrsHtml + " " + key;
  }, '');
};

exports.getAttributesHtml = getAttributesHtml;

var nodeToHtml = function nodeToHtml(node, ignoreScripts) {
  if (node.tag === 'text') {
    return node.content;
  }

  var attributes = node.attributes,
      children = node.children,
      tag = node.tag;

  if (tag === 'script' && ignoreScripts || _embed.ignoreTags.includes(tag)) {
    return '';
  }

  return _embed.selfClosingTags.includes(tag) ? "<" + tag + getAttributesHtml(attributes) + ">" : "<" + tag + getAttributesHtml(attributes) + ">" + embedDataToHtml(children) + "</" + tag + ">";
};

exports.nodeToHtml = nodeToHtml;

function embedDataToHtml(data) {
  var ignoreScripts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!data) {
    return '';
  } // Legacy format


  if (!Array.isArray(data)) {
    var allowFullscreen = data.allowFullscreen ? 'allowFullscreen="1"' : '';
    return "<iframe src=\"" + data.src + "\" width=\"" + data.width + "\" height=\"" + data.height + "\" " + allowFullscreen + " data-service=\"" + data.service + "\" frameborder=\"0\"></iframe>";
  }

  return data.reduce(function (html, node) {
    return "" + html + nodeToHtml(node, ignoreScripts);
  }, '');
}